import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { ADMIN_XE_PREFIX_URL } from './constants/config.admin-xe'

const ListPageAdminXe = lazy(() => import('./pages/ListPage.AdminXe'))

const AdminXeRouters: AppRouterItem[] = [
  {
    path: `${ADMIN_XE_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAdminXe />
      </LoadingLazyComponents>
    ),
  },
]

export default AdminXeRouters
